module.exports = __webpack_public_path__ + "img/delete.e617e7cf.svg";